import { FlexGrid, Card } from "@albo-ui/core";
import { Box, CardContent, Typography } from "@mui/material";
import CS_Work from '../../../images/cs_work.png';
import CS_Online from '../../../images/cs_online.png';
import CS_Client from '../../../images/cs_client.png';
import Check from '../../../images/check.png';
import Money from '../../../images/money.png';
import Group from '../../../images/group.png';
import ImageCarousel from '../../elements/ImageCarousel';


export const InextInit = ({ rol }: any) => {
    const images = [CS_Work, CS_Online, CS_Client];

    const data = [
        {textBold: "Accede fácilmente ", text: "a la información del cliente para ofrecer respuestas claras y oportunas.", icon: Check, side: "right"},
        {textBold: "Trazabilidad de movimientos: ", text: "gestión de datos y métricas para garantizar el cumplimiento normativo, detección de oportunidades y toma de decisiones.", icon: Money, side: "left"},
        {textBold: "Potencia la experiencia del cliente: ", text: "Cada solución cuenta, y tú eres clave en el proceso.", icon: Group, side: "right"},

    ];

    return (
        <Box sx={{width: '100%', display: 'flex', gap: 2, boxSizing: "border-box"}}>
            <Card padding={4} fullWidth style={{height: "initial"}}>
                <CardContent sx={{ height: '100%' }}>
                    <Typography variant="h5" component="div">{rol}</Typography>
                    <Typography variant="body1" color="text.secondary" sx={{ fontStyle: 'italic' }}>
                        Tu espacio para brindar soluciones rápidas y efectivas.
                    </Typography>
                    {data.map((item, i) => {
                        return (
                            <FlexGrid key={i} container style={{display: "flex", marginBottom: 10, alignItems: "center"}} spacing={2} >
                                {item.side === "left" && <Box component="img" alt={item.icon} src={item.icon} width={'100px'} sx={{verticalAlign: "middle"}}/>}
                                <Typography variant="body1" color="text.secondary" sx={{textAlign: item.side, marginLeft: item.side === "right" ? "15px" : "auto"}}><b>{item.textBold}</b>{item.text}</Typography>
                                {item.side === "right" && <Box component="img" alt={item.icon} src={item.icon} width={'120px'} sx={{verticalAlign: "middle"}}/>}
                            </FlexGrid>
                        )
                    })}

                    <Typography variant="body1" color="text.secondary" sx={{ fontStyle: 'italic' }}>
                    ¡Gracias por ser parte del equipo que transforma cada consulta en una experiencia de atención excepcional!
                    </Typography>
                </CardContent>
            </Card>
            <Card padding={4} fullWidth fullHeight style={{height: "initial"}} >
                <ImageCarousel images={images} time={5000}/>
            </Card>
        </Box>
    );
};
